import { render } from "./CartButton.vue?vue&type=template&id=d501949c"
import script from "./CartButton.vue?vue&type=script&lang=js"
export * from "./CartButton.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "d501949c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d501949c', script)) {
    api.reload('d501949c', script)
  }
  
  module.hot.accept("./CartButton.vue?vue&type=template&id=d501949c", () => {
    api.rerender('d501949c', render)
  })

}

script.__file = "src/ui/buttons/CartButton.vue"

export default script